import * as FIELD_NAME from 'constant/form-item-names'
import * as ACTION from 'constant/action'
import * as RULES from 'constant/form-rules'
import { Form, Upload, Button } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'

const UploadImage = ({ fileName, name = FIELD_NAME.IMAGE_META, title = 'Image Upload', required }) => {
  const [fileList, setFileList] = useState({ name: fileName })
  const normFile = (event) => event?.file
  return (
    <>
      <span>{title}</span>
      <Form.Item
        getValueFromEvent={normFile}
        name={name}
        rules={_.isEmpty(fileList.name) && required && [RULES.REQUIRED]}
        valuePropName='file'
      >
        <Upload
          accept='.png, .jpg, .jpeg'
          beforeUpload={() => false}
          fileList={fileName && fileList && [fileList]}
          maxCount={1}
          multiple={false}
          onChange={(event) => {
            if (event.file?.status === ACTION.REMOVED) {
              setFileList({ name: null })
            } else {
              setFileList({ name: event.file.name })
            }
          }}

        >
          <Button icon={<UploadOutlined />}>Select Image</Button>
        </Upload>
      </Form.Item>
      <p className='mb-3'><sup>*</sup> Recommended minimum image size - 1600  x  1200</p>
    </>
  )
}

UploadImage.propTypes = {
  fileName: PropTypes.string,
  name: PropTypes.string,
  required: PropTypes.bool,
  title: PropTypes.string
}

export default UploadImage
